import React, { useEffect } from 'react';
import NumberFormat from 'react-number-format';

interface InputFieldCurrencyProps {
  label?: string;
  classes?: string;
  required?: boolean;
  maxlength?: number;
  onChangeHandler: (value: string) => void;
  value: string;
  resetValue: string;
  currency?: string;
  allowNegative?: boolean;
  disabled?: boolean;
}

const InputFieldCurrency = ({
  label,
  classes = '',
  required = false,
  maxlength,
  onChangeHandler,
  value,
  resetValue = '',
  currency = '',
  allowNegative = false,
  disabled = false,
}: InputFieldCurrencyProps) => {
  useEffect(() => {
    if (value === '' || value === undefined) onChangeHandler(resetValue);
  }, [value]);

  const MAX_VAL = 999999.99; //#85302 doch wieder auf 6 Vorkommastellen begrenzen.
  const withValueLimit = (inputObj: any) => {
    const { value } = inputObj;
    if (value <= MAX_VAL) return inputObj;
  };

  return (
    <div className={`floating form-group ${classes}`}>
      <NumberFormat
        placeholder=' '
        value={value}
        defaultValue={value}
        className={classes}
        required={required}
        maxLength={maxlength}
        thousandSeparator={'.'}
        decimalSeparator={','}
        prefix={''}
        suffix={` ${currency}`}
        decimalScale={2}
        isNumericString={true}
        fixedDecimalScale={true}
        onValueChange={values => {
          onChangeHandler(values.value);
        }}
        allowNegative={allowNegative}
        isAllowed={withValueLimit}
        disabled={disabled}
      />
      <label className='floating-label'>{label}</label>
    </div>
  );
};

export default InputFieldCurrency;
